import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  getMonthName = (monthNumber) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return months[parseInt(monthNumber) - 1];
   }
  render() {
    const lastMonthDebitDetailTableData = this.props.lastMonthDebitDetailTableData;
    const total = this.props.total;
    const totalleafAmount = this.props.totalleafAmount;
    const totalInterestAmount = this.props.totalInterestAmount;
    const searchData = this.props.searchData;

    const cellStyle = {
      border: '1px solid black',
      fontSize: '15px',
    };

    return (
      <div>
        <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
          <br />
          <h2><center><u>Last Month Debit Report</u></center></h2>
          <div>&nbsp;</div>
          <h3><center>{searchData.groupName} -{searchData.factoryName}</center></h3>
          <h3><center> Month - {this.getMonthName(searchData.applicableMonth)}<center/></center></h3>
          <h3><center>Route: {searchData.routeName === undefined ? 'All Routes' : searchData.routeName}</center></h3>
          <div>&nbsp;</div>
          <div>
            <Box minWidth={1050}>
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow style={{ border: "1px solid black" }}>
                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Reg No</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Customer Name</TableCell>
                      {/* <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Leaf (Kg)</TableCell> */}
                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Debit Amount(Rs)</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Interest Amount (Rs)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {lastMonthDebitDetailTableData.map((data, index) => (
                      <TableRow style={{ border: "1px solid black" }} key={index}>
                         <TableCell component="th" scope="row" align="center" style={cellStyle}> {data.registrationNumber}</TableCell>
                         <TableCell component="th" scope="row" align="left" style={cellStyle}> {data.customerName}</TableCell>
                         <TableCell component="th" scope="row" align="right" style={cellStyle}>{data.debitAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                         <TableCell component="th" scope="row" align="right" style={cellStyle}> {data.interestAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableRow>
                    <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black", borderRight: "none", width: '20%' }}>Total </TableCell>
                    <TableCell component="th" scope="row" align="left" style={{ borderTop: "1px solid black", borderBottom: "1px solid black", borderLeft: "none", width: '20%' }}></TableCell>
                    <TableCell component="th" scope="row" align="right" style={{ border: "1px solid black", width: '20%' }}> <b>{total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                    <TableCell component="th" scope="row" align="right" style={{ border: "1px solid black", width: '20%' }}> <b>{totalInterestAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </Box>
          </div>
          <div>&nbsp;</div>
          <h4><center>*******End of List*******</center></h4>
        </div></div>
    );
  }
}
